module.exports = {"420922100":"城关镇","420922101":"阳平镇","420922102":"芳畈镇","420922103":"新城镇","420922104":"夏店镇","420922105":"刘集镇","420922106":"河口镇","420922107":"四姑镇","420922108":"吕王镇","420922109":"黄站镇","420922110":"宣化店镇","420922111":"丰店镇","420922112":"大新镇","420922113":"三里镇","420922200":"高店乡","420922201":"彭店乡","420922202":"东新乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420922.json
// module id = 1758
// module chunks = 0